// removed by extract-text-webpack-plugin
module.exports = {"img-wrapper":"index-module__img-wrapper___399in","imgWrapper":"index-module__img-wrapper___399in","overflow-hidden":"index-module__overflow-hidden___1esyM","overflowHidden":"index-module__overflow-hidden___1esyM","slick-dots":"index-module__slick-dots___1dmjd","slickDots":"index-module__slick-dots___1dmjd","slick-active":"index-module__slick-active___h8dVm","slickActive":"index-module__slick-active___h8dVm","slick-non":"index-module__slick-non___xJ2Eh","slickNon":"index-module__slick-non___xJ2Eh"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/company/media-and-partners/index.module.scss
// module id = 1715
// module chunks = 146